import React from 'react';
import { IconFormIcons } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { SideNavigationItem } from 'shared/components/ui/side-navigation-item';
import { Paths } from 'shared/routes/paths';
import { LifeArea } from 'shared/types/life-area';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

import * as Styled from './life-area-side-menu-item.style';

export type LifeAreaSideMenuItemProps = {
  lifeArea: LifeArea;
  currentPath?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  isMoving?: boolean;
  onContextMenu?: (e: React.MouseEvent) => void;
};

export const LifeAreaSideMenuItem = React.forwardRef<
  HTMLAnchorElement | HTMLDivElement,
  LifeAreaSideMenuItemProps
>(
  (
    { lifeArea, currentPath, action, children, isMoving, onContextMenu },
    ref,
  ) => {
    const isFrozen = !!lifeArea.frozenAt;
    const url = replaceUrlParams(Paths.LifeAreaDetail, { id: lifeArea.id });

    return (
      <SideNavigationItem
        ref={ref}
        start={
          <Styled.IconContainer $color={lifeArea.color}>
            <Icon icon={IconFormIcons[lifeArea.iconName]} />
          </Styled.IconContainer>
        }
        label={lifeArea.name}
        link={isFrozen ? undefined : url}
        active={!isFrozen && !!currentPath && currentPath.includes(url)}
        action={action}
        isMoving={isMoving}
        dimmed={isFrozen}
        onContextMenu={onContextMenu}
      >
        {children}
      </SideNavigationItem>
    );
  },
);
